import {useAppSelector} from 'src/redux/hooks';

export interface SuperAdminGuardProps {
  showDeniedMessage?: boolean;
  children?: React.ReactNode;
}

export const SuperAdminGuard: React.FC<SuperAdminGuardProps> = ({
  showDeniedMessage = false,
  children,
}) => {
  const {isSuperAdmin} = useAppSelector(s => s.session);

  if (isSuperAdmin) {
    return <>{children}</>;
  }

  return (
    <>
      {showDeniedMessage === true &&
        'You do not have permission to access this feature.'}
    </>
  );
};
